import { render, staticRenderFns } from "./OrderSizeTable.vue?vue&type=template&id=7dd4d0e2&scoped=true"
import script from "./OrderSizeTable.vue?vue&type=script&lang=js"
export * from "./OrderSizeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd4d0e2",
  null
  
)

export default component.exports